

    const socketUrl = import.meta.env.VITE_APP_SOCKET_URL;
    const socketPort = import.meta.env.VITE_APP_SOCKET_PORT;

    const script = document.createElement('script');
    script.src = `//${socketUrl}:${socketPort}/socket.io/socket.io.js`;

    document.head.appendChild(script);

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js');
        });
    }
